/* eslint-disable max-len */

import { useCaseOptions } from 'Pods/ThreeDStudio/Components/MainPanel/Components/LeftSide/Components/ModelSettings/Components/UseCaseSelector/useCaseOptions'

/**
 * Finds the use case whose preset the given model settings match, so a preset is
 * highlighted again once manual changes land back on its values. The preset provider
 * is not compared: switching engines never deselects a use case. No preset covers
 * extra quality, so settings with it on match none.
 *
 * @param {Object} modelSettings - The modelSettings slice.
 * @returns {string|undefined} One of USE_CASE values.
 */
export function findMatchingUseCase(modelSettings) {
  if (modelSettings.extraQuality) {
    return undefined
  }

  const match = useCaseOptions.find(({ preset }) => (
    Object.entries(preset).every(([key, value]) => key === 'provider' || modelSettings[key] === value)
  ))

  return match?.id
}
